import React, { FC } from "react";
import { Grid, IconButton, Tooltip } from "@mui/material";
import Link from "@mui/material/Link";
import clsx from "clsx";
import chatStyle from "./chat.module.css";
import { execABLProgram } from "../../../../NotWorkArea(Side&Head)/Header/Header";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { showContent } from "../../../../../TokenProcessing/TokenProcessing";

export interface MessageObj {
  Hash: string;
  mine: "0" | "1";
  Mine: "0" | "1";
  User: string;
  user: string;
  content: string;
  id: string;
  "image@height": string;
  "image@width": string;
  RCDATA?: string;
  data$type?: string;
  Files?: {
    [key: string]: {
      $tag: number;
    };
  };
}

interface ChatMessageProps {
  messageData: MessageObj;
  docId: string;
  events: { onDelete: () => void; onEdit: () => void };
}

//eslint-disable-next-line
const ChatMessage: FC<ChatMessageProps> = ({
  messageData: {
    Mine,
    mine,
    content,
    User,
    user,
    RCDATA: rcdata,
    Files: files,
    id,
    "image@height": imageHeight,
    "image@width": imageWidth,
    data$type: dataType,
  },
  docId,
  events: { onDelete, onEdit },
}) => {
  const imageData = {
    rcdata,
    imageHeight,
    imageWidth,
    dataType,
  };
  const finalMine = Mine === "1" || mine === "1";

  const handleClickLink = ({ fileName = "", tag = { $tag: 0 } }) => {
    const command = {
      module: "programs",
      params: {
        Name: "HandleChatFile",
        binary: "1",
      },
    };
    const postData = {
      fileName,
      DocID: docId,
      what: "open",
      ...tag,
    };
    execABLProgram({ command, postData });
  };

  const renderFiles = () => {
    if (!files) return null;
    return Object.entries(files).map(([key, value]) => {
      return (
        <span key={"link" + key}>
          <Link onClick={() => handleClickLink({ fileName: key, tag: value })}>{key}</Link>
          <br />
        </span>
      );
    });
  };

  return (
    <Grid
      container
      id={"messageContainer"}
      direction={finalMine ? "row-reverse" : "row"}
      sx={{
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}
    >
      <Grid
        container
        className={clsx(chatStyle.smetaMessage)}
        direction="column"
        sx={{
          justifyContent: "flex-start",
          alignItems: "flex-start",
          borderRadius: finalMine ? "4px 0px 4px 4px" : "0px 4px 4px 4px",
        }}
      >
        <Grid className={clsx(chatStyle.smetaChatFullWidth)}>
          <Grid
            container
            direction="row"
            sx={{
              justifyContent: "space-between",
              alignItems: finalMine ? "flex-start" : "center",
            }}
          >
            <Grid className={clsx(chatStyle.smetaMessageUser)}>{User || user}</Grid>
            <Grid sx={{ display: finalMine ? "" : "none" }}>
              <Tooltip title="Редактировать сообщение">
                <IconButton onClick={() => onEdit({ id, text: content, files, imageData })}>
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Удалить сообщение">
                <IconButton onClick={() => onDelete({ id })}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: rcdata ? "" : "none",
          }}
        >
          <img
            alt=""
            className={clsx(chatStyle.messageImage)}
            src={`data:image/${dataType};base64,${rcdata}`}
            onClick={() => {
              showContent({
                rcdata,
                mimeType: `data:image/${dataType || ""};base64,`,
                data: {
                  Params: {
                    FileName: `image-${id}.${dataType}`,
                  },
                },
              });
            }}
          />
        </Grid>
        <Grid>{renderFiles()}</Grid>
        <Grid className={clsx(chatStyle.messageText)}>{content}</Grid>
      </Grid>
    </Grid>
  );
};

export default ChatMessage;
